import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PaymentElement} from '@stripe/react-stripe-js';
import { setStripeMessage, setStripeIsLoading } from '../../store/AppSlice';
import '../../css/base.css';
import scenery5_large from '../../img/scenery5_large.jpg';
import { callPost } from '../../api/api';

const PaymentForm = (props) => {

  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0,0);
    dispatch(setStripeMessage(null));
    dispatch(setStripeIsLoading(false));
  }, []);

  const logBooking = (bookingDetails) => {
    let booking = {
      date: bookingDetails.arrivalDate,
      email: bookingDetails.contactDetails ? bookingDetails.contactDetails.email : null
    }

    let logBookingUrl = "/log/booking";
    return callPost(logBookingUrl, booking).then((response) => {});
  }

  const isPayment = () => {
    const { stripeMessage, stripeIsLoading } = appstate;
    const { stripe, elements } = props;

    console.log("Stripe error is:" + stripeMessage);
    console.log("Stripe is loading: " + stripeIsLoading);
    console.log("Stripe: " + stripe);
    console.log("Stripe elements: " + elements);

    return (
      <div>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="keyText">
              <h4 className="availabilityCalendarTextBox">Payment<span style={{"fontSize": "0.8rem"}}>&nbsp; &nbsp;&nbsp;(Step 4 of 4)</span></h4>
            </div>            
          </div>
        </div>          
        <div className="row" style={{"margin": "1rem 0 1rem 0"}}>
          <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" />
            <button disabled={stripeIsLoading || !stripe || !elements} id="submit" className="pay-now-button">
              <span id="button-text">
                Pay now
              </span>
              {stripeIsLoading ? <div className="loader" id="loader" /> : null}
            </button>
          </form>
        </div>
        {stripeMessage &&
        <div className="row" style={{"margin-left": "-1.2rem"}}>
          <div className="col-12">
            <div className="generalText">
              <div className="generalTextBox">
                <p className="error-text">{stripeMessage}
                </p>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    );        
  
  }

  const handleSubmit = async (event) => {
    const { bookingDetails, bookings } = appstate;

    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    const {stripe, elements} = props;

    dispatch(setStripeIsLoading(true));
    logBooking(bookingDetails);
    window.localStorage.setItem("booking-details", JSON.stringify(bookingDetails));
    window.localStorage.setItem("bookings", JSON.stringify(bookings));

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
       
    const { error } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
//        return_url: "http://localhost:3000/success",
        return_url: "https://shorecottage.org/success",
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      dispatch(setStripeMessage(error.message));
    } else {
      dispatch(setStripeMessage("An unexpected error occurred."));
    }

    dispatch(setStripeIsLoading(false));
  };

  return (
      <div className="row">
        <div className="col-12 col-md-6 imagesBackgroundColour">
          {isPayment()}
        </div>
        <div className="col-12 col-md-6 imagesBackgroundColour">
          <img src={scenery5_large} alt="Welcome Door" className="gallery-image" />
        </div>
      </div>
  );
}

export default PaymentForm